import { render, staticRenderFns } from "./setMealStatistics.vue?vue&type=template&id=548dd02e&"
import script from "./setMealStatistics.vue?vue&type=script&lang=ts&"
export * from "./setMealStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports